var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.828,
    height: 24.828,
    viewBox: "0 0 24.828 24.828",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_695",
    "data-name": "Groupe 695",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_892",
    "data-name": "Trac\\xE9 892",
    d: "M12.414,0C9.045,0,8.621.016,7.3.074A9.147,9.147,0,0,0,4.283.652a6.078,6.078,0,0,0-2.2,1.432,6.094,6.094,0,0,0-1.432,2.2,9.093,9.093,0,0,0-.577,3.01C.016,8.62,0,9.042,0,12.415s.016,3.792.074,5.116a9.145,9.145,0,0,0,.577,3.013,6.355,6.355,0,0,0,3.629,3.631,9.114,9.114,0,0,0,3.013.577c1.325.059,1.747.074,5.119.074s3.792-.016,5.118-.074a9.164,9.164,0,0,0,3.015-.577,6.355,6.355,0,0,0,3.629-3.631,9.186,9.186,0,0,0,.577-3.013c.059-1.324.074-1.746.074-5.118s-.016-3.794-.074-5.119a9.175,9.175,0,0,0-.577-3.012,6.092,6.092,0,0,0-1.432-2.2,6.069,6.069,0,0,0-2.2-1.432A9.132,9.132,0,0,0,17.53.074C16.2.016,15.784,0,12.411,0h0ZM11.3,2.238h1.114c3.314,0,3.707.011,5.015.071a6.879,6.879,0,0,1,2.306.427,3.852,3.852,0,0,1,1.428.929,3.835,3.835,0,0,1,.928,1.428,6.818,6.818,0,0,1,.427,2.3c.061,1.308.073,1.7.073,5.014s-.012,3.707-.073,5.015a6.868,6.868,0,0,1-.427,2.3,4.114,4.114,0,0,1-2.357,2.354,6.829,6.829,0,0,1-2.3.428c-1.308.059-1.7.073-5.015.073s-3.709-.014-5.017-.073a6.857,6.857,0,0,1-2.3-.428,3.845,3.845,0,0,1-1.428-.928,3.848,3.848,0,0,1-.931-1.428,6.858,6.858,0,0,1-.427-2.3c-.059-1.308-.071-1.7-.071-5.017S2.25,8.7,2.309,7.394a6.868,6.868,0,0,1,.428-2.306,3.852,3.852,0,0,1,.929-1.428,3.835,3.835,0,0,1,1.428-.928A6.857,6.857,0,0,1,7.4,2.3c1.145-.053,1.589-.068,3.9-.07v0ZM19.041,4.3a1.49,1.49,0,1,0,1.49,1.49,1.49,1.49,0,0,0-1.49-1.49ZM12.415,6.039a6.376,6.376,0,1,0,6.376,6.376,6.375,6.375,0,0,0-6.376-6.376Zm0,2.236a4.138,4.138,0,1,1-4.138,4.138A4.138,4.138,0,0,1,12.415,8.275Z",
    transform: "translate(0 0)",
    fill: "#0ef5ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.6a1a22e4e0150f585b7009f101dffe79.svg";
export { ForwardRef as ReactComponent };